window.updateDynamicBannerLink = async function ({
  buttonSelector,
  apiUrl,
  fallbackUrl,
  buttonText,
  buttonTarget = "_self",
}) {
  const button = document.querySelector(buttonSelector);
  if (!button) return;

  function isValidTrackingUrl(url) {
    // Only allow URLs that start with your domain and expected path
    return /^https:\/\/myhes\.de\/de\/tracking\/[a-zA-Z0-9_-]+$/.test(url);
  }

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (response.ok) {
      const data = await response.json();
      const trackingNumber = data?.shipmentData?.shipmentTrackingNumber;
      const dynamicUrl = trackingNumber
        ? `https://myhes.de/de/tracking/${encodeURIComponent(trackingNumber)}`
        : "/";

      if (isValidTrackingUrl(dynamicUrl)) {
        button.textContent = data.buttonText || buttonText || "Click Here";
        button.onclick = () => window.open(dynamicUrl, buttonTarget);
        button.style.display = "inline-flex";
      } else {
        throw new Error("Invalid tracking URL");
      }
    } else {
      throw new Error("Failed to fetch dynamic button data");
    }
  } catch (error) {
    console.error("Error fetching dynamic button data:", error);
    if (fallbackUrl) {
      button.textContent = buttonText;
      button.onclick = () => window.open(fallbackUrl, buttonTarget);
      button.style.display = "inline";
    }
  }
};
